import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoginVisible, setSignupVisible} from '../../features/dialogControl/dialogControlSlice';
import { 
    IconButton,
    Box,
    Button
} from "@mui/material";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import './signup.css';
import { CustomTextField } from '../form-elements/form-elements'; 
import { useTheme } from '@mui/material/styles';
// import { getServerEndpoint } from '../../utils/utils';
import { graphqlRequest } from '../../services/graphql-service';
import { CHECK_USER_EXISTENCE } from '../../config/queries';
import { createUser } from '../../features/user/userSlice';
import { toast } from 'react-toastify'; 
// import { confirmSignup } from '../../features/email/emailSlice';

// import {
//   FacebookLoginButton,
//   GoogleLoginButton,
// } from "react-social-login-buttons";


const initialSignupData = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
}


const SignUp = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [signupData, setSignupData] = useState(initialSignupData);
    const [error, setError] = useState('');
    // const serverEndpoint = getServerEndpoint();

    const handleCancelClick = (event) => {
        event.stopPropagation();
        if (event.target.id !== 'dialog-container') dispatch(setSignupVisible(false));
    }

    const handleFormChange = (field, value) => {
        const updatedData = { ...signupData, [field]: value };
        setSignupData(updatedData); 
    }

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     console.log("Form submitted:", signupData);
    //     dispatch(setSignupVisible(false));
    // };

    const handleAccountCreateSubmit = async (event) => {
        event.preventDefault();
        console.log("submiting");
        try {

            console.log("checking if user already exists");
            // bounce if user already exists
            const checkUserResponse = await graphqlRequest(CHECK_USER_EXISTENCE, { email: signupData.email });

            console.log('checkUserResponse: ')
            console.log(checkUserResponse)

            if (checkUserResponse.userByEmail) {
                console.log('checkUserResponse.userByEmail: ');
                console.log(checkUserResponse.userByEmail);
                setError('User with this email already exists.');
                toast.error('User with this email already exists.');
                return;
            }
            
            // proceed with user creation
            const variables = {
                first_name: signupData.firstName,
                last_name: signupData.lastName,
                email: signupData.email, 
                password: signupData.password,
            };

            dispatch(createUser(variables))
            .unwrap()
            .then((newUser) => {
                toast.success(`Account created successfully for ${newUser.email}, please login.`);
                dispatch(setSignupVisible(false));
                dispatch(setLoginVisible(true)); // take user to login
                // const confirmationData = {
                //     email: signupData.email
                // }
                // dispatch(confirmSignup(confirmationData)); // trigger signup confirmation email
                setSignupData(initialSignupData);
            })
            .catch((error) => {
                toast.error(`Error: ${error}`);
                setError(error);
            });
        } catch (error) {
            console.error('Error creating user:', error);
            setError(error.message);
        }
    };

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(setLoginVisible(true));
        dispatch(setSignupVisible(false));
    };


    return (
        <div className='screen'>
            <div id='dialog-container' className='signup-dialog-container'>
                <div className='dialog-header'>Join the MusicBlox Beta Wait List</div>
                <Box 
                    component="form"
                    onSubmit={(e) => handleAccountCreateSubmit(e)}
                    autoComplete='off'
                    sx={{ 
                        display:'flex', 
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                    }}
                >
                    <div className='dialog-sub-text'>CREATE YOUR ACCOUNT</div>
                    <Box>
                        <CustomTextField
                            sx={{
                                width: '500px'
                            }}
                            size="small"
                            label="FIRST NAME"
                            name="email"
                            value={signupData.firstName}
                            onChange={(e) => handleFormChange("firstName", e.target.value)}
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                        />
                    </Box>

                    <Box>
                        <CustomTextField
                            sx={{
                                width: '500px'
                            }}
                            size="small"
                            label="LAST NAME"
                            name="email"
                            value={signupData.lastName}
                            onChange={(e) => handleFormChange("lastName", e.target.value)}
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                        />
                    </Box>
                    <Box>
                        <CustomTextField
                            sx={{
                                width: '500px'
                            }}
                            size="small"
                            label="EMAIL"
                            name="email"
                            value={signupData.email}
                            onChange={(e) => handleFormChange("email", e.target.value)}
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                        />
                    </Box>

                    <Box>
                        <CustomTextField
                            sx={{
                                width: '500px'
                            }}
                            size="small"
                            type="password"
                            label="PASSWORD"
                            name="password"
                            value={signupData.password}
                            onChange={(e) => handleFormChange("password", e.target.value)}
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                        />
                    </Box>

                    {error && (
                        <Box 
                            sx={{ 
                                color: 'red', 
                                fontSize: '14px', 
                                marginBottom: '10px' 
                            }}
                        >
                            {error}
                        </Box>
                    )}

                    <Button 
                        sx={{
                            width:'86px',
                            height: '32px',
                            borderRadius: '4px',
                            marginBottom: '20px'
                        }}
                        type="submit" 
                        variant="contained" 
                        color="primary" 
                        fullWidth
                    >
                        Submit
                    </Button>
                    
                    {/* <div className='dialog-sub-text'>OR CREATE ACCOUNT WITH</div>
                    
                    <Box
                        sx={{
                            marginBottom: '10px',
                            display:'flex'
                        }}
                    >
                        <GoogleLoginButton 
                            onClick={() => console.log('google login')} 
                            style={{
                                display:'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                borderRadius: '20px',
                                height: '40px',
                                width: '200px',
                                margin: '0px'
                            }}
                        />
                        <FacebookLoginButton 
                            onClick={() => console.log('google login')} 
                            style={{
                                display:'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                borderRadius: '20px',
                                height: '40px',
                                width: '200px',
                                margin: '0 0 0 20px'
                            }}
                        />
                    </Box> */}

                    <Box 
                        sx={{marginTop: '10px'}}
                    >
                        <p
                            className='dialog-help-note'
                        >
                            Already have an account? 
                            <NavLink 
                                className='dialog-help-link' 
                                to='/'
                                onClick={(event) => handleLogin(event)} 
                            >
                                Sign in 
                            </NavLink>
                        </p>

                        <p
                            className='dialog-help-note'
                        >
                            Having trouble? 
                            <NavLink 
                                className='dialog-help-link' 
                                to='/'
                                onClick={(event) => handleLogin(event)} 
                            >
                                Reach out 
                            </NavLink>
                        </p>
                    </Box>
                
                </Box>

                
                <div className='close-button'>
                    <IconButton
                        onClick={(event) => handleCancelClick(event)}
                    >
                        <CancelOutlinedIcon 
                            sx= {{
                                color:theme.palette.color
                            }}
                        />
                    </IconButton>
                </div>
            </div>
        </div>
    );
}

export default SignUp;